import axios from 'axios';
import { call } from 'redux-saga/effects';
import {
    GET_CONTENT_BY_TAG_ENDPOINT,
    SEARCH_ENTITY_IN_SITE_ENDPOINT
} from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getContentByTag(payload) {
    const header = tokenHeader();
    const COMPLETE_URL = GET_CONTENT_BY_TAG_ENDPOINT + payload;
    return yield call(axios.get, COMPLETE_URL, {}, { header });
}

export function* searchEntityInSite(payload) {
    const header = tokenHeader();
    
    let api_url_dynamic = SEARCH_ENTITY_IN_SITE_ENDPOINT.replace('entity', payload.entity) + `&find=${payload.searchedText}`;

    return yield call(axios.get, api_url_dynamic, header);
}




// WEBPACK FOOTER //
// ./src/SHARED/api/searchresults.api.js